import { render, staticRenderFns } from "./Repositories.vue?vue&type=template&id=38214f78&"
import script from "./Repositories.vue?vue&type=script&lang=js&"
export * from "./Repositories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38214f78')) {
      api.createRecord('38214f78', component.options)
    } else {
      api.reload('38214f78', component.options)
    }
    module.hot.accept("./Repositories.vue?vue&type=template&id=38214f78&", function () {
      api.rerender('38214f78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/repositories/Repositories.vue"
export default component.exports